import type { ReactNode } from 'react';
import { Link, useLocation } from 'react-router';
import { Breadcrumb } from 'antd';
import './index.scss';
import { getMenusFromDataRoutes } from '@/router/config';

const dynamicBreadcrumbRules: Array<{ pattern: RegExp; title: string }> = [
  { pattern: /^\/projects$/, title: 'My Projects' },
  { pattern: /^\/projects\/[^/]+\/dashboard$/, title: 'Dashboard' },
  { pattern: /^\/projects\/[^/]+\/editor$/, title: 'Editor' },
];

const getTitleByPath = (path: string) => {
  let title = '';
  getMenusFromDataRoutes().forEach((menu) => {
    if (menu.subMenu) {
      const subMenu = menu.subMenu.find((item) => item.path === path);
      if (subMenu) {
        title = subMenu.title;
      }
    }
    if (menu.path === path) {
      title = menu.title;
    }
  });
  if (!title) {
    const matchedRule = dynamicBreadcrumbRules.find((rule) => rule.pattern.test(path));
    if (matchedRule) {
      title = matchedRule.title;
    }
  }
  return title;
};

export const BreadcrumbView = () => {
  const location = useLocation();
  const pathSnippets = location.pathname.split('/').filter((i: string) => i) as string[];

  const extraBreadcrumbItems = pathSnippets.reduce<Array<{ key: string; title: ReactNode }>>(
    (items, _item, index) => {
      const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
      const title = getTitleByPath(url);
      if (!title) {
        return items;
      }
      items.push({
        key: url,
        title: <Link to={url}>{title}</Link>,
      });
      return items;
    },
    [],
  );

  return <Breadcrumb items={extraBreadcrumbItems} style={{ backgroundColor: 'transparent' }} />;
};
